export default () => ({
  variables: []
});
